/* Restaurant Halong 2026-10-09 (UI-Prüfung, KRITISCH-Befund "Drawer ohne Fuß"): Warenkorb-Wächter.

   Problem: Impact (theme.js, CartDrawer._onCartChanged) tauscht bei item_count > 0 nur die INHALTE von
   .cart-drawer__inner und [slot="footer"], die Klassen bleiben stehen. Kommt der Gast aus dem leeren Warenkorb,
   behält der Fuß "d-none" und der Drawer zeigt das Gericht ohne Summe und ohne Kasse. Zusätzlich wirft Impact einen
   TypeError, wenn ein cart:change-Event kein Sektions-HTML trägt (Live-Fehlerbild), und es gibt Wege, auf denen der
   Drawer veraltet (zweiter Tab, bfcache, sich überholende Antworten).

   Lösung (eine Quelle der Wahrheit = Section Rendering API von Shopify, kein Eingriff in theme.js):
   1. Wächter: ungültige cart:change-Events (ohne cart, ohne/leeres Sektions-HTML) erreichen Impact nicht mehr;
      stattdessen wird der Stand vom Server geholt und ein vollständiges Event nachgereicht.
   2. Invariante: Fuß sichtbar genau dann, wenn Positionen im Drawer stehen. Wird bei jeder DOM-Änderung des Drawers
      vor dem nächsten Zeichnen hergestellt (MutationObserver, Mikrotask), unabhängig davon, wer geändert hat.
   3. Abgleich: Nach jeder Änderung wird der Drawer gegen das zuletzt bekannte Server-HTML geprüft (lokal, ohne
      Netz); bei sich überlappenden Änderungen, Tab-Wechsel, bfcache oder Abweichung gegen den Server (cart.js +
      ?sections=). Nur die jeweils letzte Anfrage zählt (AbortController + Laufnummer).
   4. Fokus und die noch nicht gespeicherte Abholtag-Wahl überstehen das Neuzeichnen.

   Schnittstelle: window.__halongWarenkorb (eingefroren). Diagnose: localStorage.halongWarenkorbDebug = '1'.
   Rückweg: Script-Zeile in layout/theme.liquid entfernen; custom-script.js fällt dann auf cart:refresh zurück. */
(function () {
  'use strict';

  if (window.__halongWarenkorb) return;

  var VERSION = '2026-10-09.1';
  var ZEITLIMIT_MS = 8000;          // je Netzabruf
  var ENTPRELLEN_MS = 250;          // Abgleich nach Ereignissen
  var MO_ENTPRELLEN_MS = 100;       // lokale Prüfung nach DOM-Änderungen
  var IMPACT_VERZOEGERUNG_MS = 1250; // CartDrawer setzt den Inhalt bei baseEvent != variant:add so spät
  var IMPACT_LEER_ANIMATION_MS = 200; // Ausblenden 150 ms + Puffer
  var PUFFER_MS = 50;
  var WIEDERHOLUNGEN = 2;           // Netzfehler: zwei weitere Versuche (500 ms, 1000 ms)
  var FOKUS_FENSTER_MS = 4000;
  var SICHTBAR_NACH_MS = 2000;      // Tab-Rückkehr erst nach längerer Abwesenheit abgleichen
  var FOKUS_DROSSEL_MS = 5000;
  var FOKUSIERBAR = 'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var debug = false;
  try { debug = window.localStorage.getItem('halongWarenkorbDebug') === '1'; } catch (e) { /* privat/gesperrt: ohne Debug */ }

  var zustand = {
    laufNr: 0,            // Abgleich: nur die letzte Antwort zählt
    laufCtrl: null,
    hinzuNr: 0,           // nachHinzufuegen: nur der letzte Aufruf zählt
    hinzuCtrl: null,
    timer: null,
    lokalTimer: null,
    ruheBis: 0,           // bis dahin schreibt Impact noch am Drawer
    ueberlappend: false,  // zwei Änderungen innerhalb der Impact-Ruhezeit: lokale Prüfung reicht nicht
    erwartet: null,       // Signatur des zuletzt bekannten Server-Stands
    vertrauenswuerdig: true,
    stoerung: null,       // { sig, stufe } bei wiederholter Abweichung
    fokus: null,          // { beschreibung, zeit }
    abholzeit: null,      // zuletzt bekanntes <halong-abholzeit>
    beobachtet: null,     // Drawer, an dem der MutationObserver hängt
    versteckt: 0,
    letzterFokusAbgleich: 0,
    warnungen: {},
    zaehler: { abgleiche: 0, korrekturen: 0, geblockt: 0, geheilt: 0, eskalationen: 0, netzfehler: 0 }
  };

  /* ---------- Hilfen ---------- */

  function log() { if (debug && window.console) console.info.apply(console, ['[halong-warenkorb]'].concat([].slice.call(arguments))); }
  function warnEinmal(art, nachricht, fehler) {
    if (zustand.warnungen[art]) return;
    zustand.warnungen[art] = true;
    if (window.console) console.warn('[halong-warenkorb] ' + nachricht, fehler && fehler.message ? fehler.message : (fehler || ''));
  }
  function wurzel() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function drawer() { return document.querySelector('cart-drawer'); }
  function sektionsId(el) {
    var s = el && el.closest('.shopify-section');
    return s && s.id ? s.id.replace('shopify-section-', '') : null;
  }
  function istVorschau() {
    var t = window.Shopify && window.Shopify.theme;
    return !!(t && t.id && t.role && t.role !== 'main');
  }
  function attr(s) { return String(s).replace(/["\\]/g, '\\$&'); }
  function norm(s) { return String(s || '').replace(/\s+/g, ' ').trim(); }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function datenFehler(text) { var e = new Error(text); e.halongDaten = true; return e; }
  function istAbbruch(e) { return !!e && (e.name === 'AbortError' || e.halongAbbruch === true); }
  function feuere(name, detail, ziel) {
    (ziel || document.documentElement).dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
  }

  /* ---------- Netz ---------- */

  function mitZeitlimit(signal) {
    var ctrl = new AbortController();
    var timer = setTimeout(function () { var e = new Error('Zeitlimit'); e.name = 'TimeoutError'; ctrl.abort(e); }, ZEITLIMIT_MS);
    function weiter() { ctrl.abort(); }
    if (signal) { if (signal.aborted) weiter(); else signal.addEventListener('abort', weiter); }
    return {
      signal: ctrl.signal,
      fertig: function () { clearTimeout(timer); if (signal) signal.removeEventListener('abort', weiter); }
    };
  }

  function holeJson(url, signal) {
    var z = mitZeitlimit(signal);
    return fetch(url, { signal: z.signal, credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) {
          var e = new Error('HTTP ' + r.status + ' bei ' + url);
          if (r.status !== 429 && r.status < 500) e.halongDaten = true; // 5xx und 429 sind vorübergehend: wiederholen
          throw e;
        }
        return r.json();
      })
      .then(function (j) { z.fertig(); return j; }, function (e) {
        z.fertig();
        if (signal && signal.aborted) { var a = new Error('abgebrochen'); a.halongAbbruch = true; throw a; }
        throw e;
      });
  }

  function holeSektionen(ids, pflichtId, signal) {
    var url = wurzel() + '?sections=' + encodeURIComponent(ids.join(','));
    return holeJson(url, signal).then(function (json) {
      if (json && typeof json[pflichtId] === 'string') return json;
      // Vorschau ohne Vorschau-Cookie liefert null (gemessen 2026-10-09): einmal mit preview_theme_id nachfragen.
      if (!istVorschau()) throw datenFehler('Sektions-HTML fehlt (' + pflichtId + ')');
      return holeJson(url + '&preview_theme_id=' + encodeURIComponent(window.Shopify.theme.id), signal).then(function (j2) {
        if (j2 && typeof j2[pflichtId] === 'string') return j2;
        throw datenFehler('Sektions-HTML fehlt auch mit preview_theme_id (' + pflichtId + ')');
      });
    });
  }

  /** Prüft, ob cart.js und Sektions-HTML zusammenpassen. Liefert '' oder eine Fehlerbeschreibung. */
  function pruefeStand(cart, html) {
    if (!cart || typeof cart.item_count !== 'number') return 'cart ohne item_count';
    if (typeof html !== 'string' || !html) return 'kein Sektions-HTML';
    var doc = parse(html);
    var inner = doc.querySelector('.cart-drawer__inner');
    var fuss = doc.querySelector('[slot="footer"]');
    if (!doc.querySelector('.cart-drawer') || !inner || !fuss) return 'Sektions-HTML unvollständig';
    var leer = cart.item_count === 0;
    if (fuss.classList.contains('d-none') !== leer) return 'Fuß passt nicht zu item_count';
    var positionen = doc.querySelectorAll('line-item').length;
    if (leer ? positionen !== 0 : positionen === 0) return 'Positionen passen nicht zu item_count';
    var zaehler = doc.querySelector('.cart-drawer__top cart-count, cart-count');
    if (zaehler && /^\s*\d+\s*$/.test(zaehler.textContent) && parseInt(zaehler.textContent, 10) !== cart.item_count) {
      return 'cart.js und Sektion zeigen unterschiedliche Stände (' + cart.item_count + ' / ' + norm(zaehler.textContent) + ')';
    }
    return '';
  }

  /** Lädt cart.js und Sektions-HTML parallel; bei unterschiedlichem Stand (Rennen auf dem Server) ein zweites Mal. */
  function holeStand(signal, ids, pflichtId) {
    function versuch(n) {
      return Promise.all([holeJson(wurzel() + 'cart.js', signal), holeSektionen(ids, pflichtId, signal)]).then(function (r) {
        var fehler = pruefeStand(r[0], r[1][pflichtId]);
        if (!fehler) return { cart: r[0], sektionen: r[1], html: r[1][pflichtId] };
        if (n >= 1) throw datenFehler(fehler);
        log('Stand inkonsistent, zweiter Versuch:', fehler);
        return versuch(n + 1);
      });
    }
    return versuch(0);
  }

  function mitWiederholung(fn, signal) {
    function lauf(n) {
      return fn().catch(function (e) {
        if (istAbbruch(e) || e.halongDaten || n >= WIEDERHOLUNGEN || (signal && signal.aborted)) throw e;
        zustand.zaehler.netzfehler++;
        return new Promise(function (ok, nein) {
          var t = setTimeout(function () { lauf(n + 1).then(ok, nein); }, 500 * Math.pow(2, n));
          if (signal) signal.addEventListener('abort', function () { clearTimeout(t); var a = new Error('abgebrochen'); a.halongAbbruch = true; nein(a); });
        });
      });
    }
    return lauf(0);
  }

  /* ---------- Signatur und Invariante ---------- */

  /** Text eines Elements ohne Theme-Fehlerbanner ([role="alert"], z. B. "nur 3 verfügbar"), die nur im DOM stehen. */
  function textOhneHinweise(el) {
    var teile = [];
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    for (var n = w.nextNode(); n; n = w.nextNode()) {
      var p = n.parentElement;
      if (p && p.closest('[role="alert"]') && el.contains(p.closest('[role="alert"]'))) continue;
      teile.push(n.nodeValue);
    }
    return norm(teile.join(' '));
  }

  /** Inhaltlicher Fingerabdruck des Drawers. Zähler und Abholzeit-Auswahl sind bewusst nicht enthalten (clientseitig). */
  function signatur(scope) {
    var inner = scope.querySelector('.cart-drawer__inner');
    var fuss = scope.querySelector('[slot="footer"]');
    if (!inner || !fuss) return null;
    var positionen = [].map.call(scope.querySelectorAll('line-item'), function (li) {
      var q = li.querySelector('[data-line-key]');
      return [q ? q.getAttribute('data-line-key') : '', q ? q.getAttribute('value') : '', textOhneHinweise(li)].join('|');
    });
    // Nur Rabatt- und Summenzeilen; Bestellhinweis-Knopf und Abholzeit ändern sich clientseitig und gehören nicht hinein.
    var summe = [].map.call(fuss.querySelectorAll('.v-stack.gap-1 > .h-stack'), textOhneHinweise);
    return JSON.stringify({
      leer: inner.classList.contains('empty-cart'),
      fussVersteckt: fuss.classList.contains('d-none'),
      positionen: positionen,
      summe: summe
    });
  }

  /** Fuß sichtbar genau dann, wenn Positionen da sind. Idempotent; ändert nur, was abweicht. */
  function invariante(d) {
    var inner = d.querySelector('.cart-drawer__inner');
    var fuss = d.querySelector('[slot="footer"]');
    var hatPositionen = d.querySelector('line-item') !== null;
    if (hatPositionen && !fuss) return 'fuss-fehlt';
    var geaendert = false;
    if (hatPositionen) {
      if (fuss.classList.contains('d-none')) { fuss.classList.remove('d-none'); geaendert = true; }
      if (inner && inner.classList.contains('empty-cart')) { inner.classList.remove('empty-cart'); geaendert = true; }
    } else if (d.querySelector('.empty-state')) {
      if (fuss && !fuss.classList.contains('d-none')) { fuss.classList.add('d-none'); geaendert = true; }
      if (inner && !inner.classList.contains('empty-cart')) { inner.classList.add('empty-cart'); geaendert = true; }
    }
    if (geaendert) { zustand.zaehler.geheilt++; log('Invariante hergestellt (Fuß/Leer-Klasse)'); }
    return 'ok';
  }

  /* ---------- Fokus und Abholzeit ---------- */

  function fokusMerken(d) {
    var a = document.activeElement;
    if (!d || !a || a === document.body || a === d || !d.contains(a)) return;
    var li = a.closest('line-item');
    var keyEl = li && li.querySelector('[data-line-key]');
    zustand.fokus = {
      zeit: Date.now(),
      el: a,
      id: a.id || null,
      name: a.getAttribute('name'),
      key: keyEl ? keyEl.getAttribute('data-line-key') : null,
      index: li ? [].indexOf.call(li.querySelectorAll(FOKUSIERBAR), a) : -1
    };
  }

  function fokusPruefen(d) {
    var f = zustand.fokus;
    if (!f || Date.now() - f.zeit > FOKUS_FENSTER_MS || !d.hasAttribute('open')) return;
    var a = document.activeElement;
    if (a && a !== document.body && a.isConnected) return; // Fokus ist (noch) gültig
    var ziel = null;
    if (f.id) ziel = d.querySelector('[id="' + attr(f.id) + '"]');
    if (!ziel && f.name && !f.key) ziel = d.querySelector('[name="' + attr(f.name) + '"]');
    if (!ziel && f.key) {
      var li = [].find.call(d.querySelectorAll('line-item'), function (l) { return l.querySelector('[data-line-key="' + attr(f.key) + '"]'); });
      if (li && f.index >= 0) ziel = li.querySelectorAll(FOKUSIERBAR)[f.index] || null;
    }
    if (!ziel) ziel = d.querySelector('[is="close-button"], .drawer__close-icon');
    if (ziel && typeof ziel.focus === 'function') {
      ziel.focus({ preventScroll: true });
      log('Fokus wiederhergestellt auf', ziel.tagName, ziel.getAttribute('name') || ziel.className);
    }
  }

  /** Überträgt eine noch nicht gespeicherte Abholtag-/Uhrzeit-Wahl auf das neu gezeichnete Element. */
  function abholzeitPruefen(d) {
    var neu = d.querySelector('halong-abholzeit');
    var alt = zustand.abholzeit;
    zustand.abholzeit = neu || alt;
    if (!neu || !alt || neu === alt || alt.isConnected) return;
    var s = alt.state;
    if (!s || !s.iso || !neu.state || !Array.isArray(neu.days) || typeof neu.update !== 'function') return;
    var gespeichert = {};
    try { gespeichert = JSON.parse(neu.dataset.saved || '{}'); } catch (e) { gespeichert = {}; }
    if (gespeichert.Abholzeit) return; // Server kennt eine gespeicherte Wahl: die gewinnt (z. B. aus zweitem Tab)
    var tag = neu.days.find(function (t) { return t.iso === s.iso; });
    if (!tag) return;
    var zeit = s.time && tag.slots.indexOf(s.time) !== -1 ? s.time : '';
    if (neu.state.iso === s.iso && neu.state.time === zeit) return;
    neu.state = { iso: s.iso, time: zeit };
    neu.update();
    log('Abholzeit-Wahl übertragen', s.iso, zeit);
  }

  /* ---------- Beobachtung ---------- */

  var beobachter = typeof MutationObserver === 'function' ? new MutationObserver(beiMutation) : null;

  function beobachte() {
    var d = drawer();
    if (!d || !beobachter || zustand.beobachtet === d) return d;
    beobachter.disconnect();
    beobachter.observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    zustand.beobachtet = d;
    if (!zustand.abholzeit) zustand.abholzeit = d.querySelector('halong-abholzeit');
    return d;
  }

  function beiMutation() {
    var d = drawer();
    if (!d) return;
    if (invariante(d) === 'fuss-fehlt') { zustand.vertrauenswuerdig = false; planeAbgleich('fuss-fehlt', 0); }
    abholzeitPruefen(d);
    fokusPruefen(d);
    clearTimeout(zustand.lokalTimer);
    zustand.lokalTimer = setTimeout(lokalePruefung, Math.max(MO_ENTPRELLEN_MS, zustand.ruheBis - Date.now() + PUFFER_MS));
  }

  /** Vergleicht den Drawer mit dem zuletzt bekannten Server-Stand, ohne Netz. Weicht er ab: Abgleich mit dem Server. */
  function lokalePruefung() {
    var d = drawer();
    if (!d) return;
    var rest = zustand.ruheBis - Date.now();
    if (rest > 0) { clearTimeout(zustand.lokalTimer); zustand.lokalTimer = setTimeout(lokalePruefung, rest + PUFFER_MS); return; }
    if (zustand.laufCtrl || zustand.hinzuCtrl) return; // Abgleich läuft bereits
    if (zustand.ueberlappend) { zustand.ueberlappend = false; planeAbgleich('ueberlappend', 0); return; }
    if (zustand.erwartet && signatur(d) === zustand.erwartet) { zustand.vertrauenswuerdig = true; return; }
    if (!zustand.erwartet) return;
    zustand.vertrauenswuerdig = false;
    planeAbgleich('lokale-abweichung', 0);
  }

  /* ---------- Abgleich mit dem Server ---------- */

  function bricheAbgleichAb() {
    clearTimeout(zustand.timer);
    if (zustand.laufCtrl) { zustand.laufCtrl.abort(); zustand.laufCtrl = null; }
    zustand.laufNr++;
  }

  function planeAbgleich(grund, verzoegerung) {
    clearTimeout(zustand.timer);
    var warte = Math.max(verzoegerung == null ? ENTPRELLEN_MS : verzoegerung, zustand.ruheBis - Date.now() + PUFFER_MS, 0);
    zustand.timer = setTimeout(function () { abgleichen(grund); }, warte);
  }

  function sektionenFuer(d) {
    var ids = [];
    feuere('cart:prepare-bundled-sections', { sections: ids });
    var id = sektionsId(d);
    if (id && ids.indexOf(id) === -1) ids.push(id);
    return { ids: ids.filter(function (x, i) { return x && ids.indexOf(x) === i; }), id: id };
  }

  /** Meldet einen geprüften Server-Stand über den offiziellen Theme-Weg (Drawer, Zähler, fetchCart, Versandbalken). */
  function meldeStand(stand, quelle) {
    var cart = Object.assign({}, stand.cart, { sections: stand.sektionen });
    zustand.zaehler.korrekturen++;
    feuere('cart:change', { baseEvent: 'variant:add', cart: cart, halongGeprueft: true, halongQuelle: quelle });
  }

  function ersetzeDrawer(d, html) {
    var neu = parse(html).querySelector('.cart-drawer');
    if (!neu) return false;
    fokusMerken(d);
    d.replaceChildren.apply(d, Array.prototype.slice.call(neu.childNodes)); // wie Impact _onCartChanged (Adoption)
    zustand.ruheBis = Date.now();
    return true;
  }

  function abgleichen(grund) {
    var d = beobachte();
    if (!d) return Promise.resolve('kein-drawer');
    var rest = zustand.ruheBis - Date.now();
    if (rest > 0) { planeAbgleich(grund, rest + PUFFER_MS); return Promise.resolve('verschoben'); }
    bricheAbgleichAb();
    var ctrl = zustand.laufCtrl = new AbortController();
    var nr = zustand.laufNr;
    var s = sektionenFuer(d);
    if (!s.id) { zustand.laufCtrl = null; return Promise.resolve('keine-sektion'); }
    zustand.zaehler.abgleiche++;
    log('Abgleich', grund);
    return mitWiederholung(function () { return holeStand(ctrl.signal, s.ids, s.id); }, ctrl.signal).then(function (stand) {
      if (nr !== zustand.laufNr) return 'ueberholt';
      zustand.laufCtrl = null;
      if (zustand.ruheBis > Date.now()) { planeAbgleich(grund, 0); return 'verschoben'; } // inzwischen neue Änderung
      var soll = signatur(parse(stand.html));
      zustand.erwartet = soll;
      if (signatur(d) === soll) {
        zustand.vertrauenswuerdig = true;
        zustand.stoerung = null;
        return 'gleich';
      }
      return eskaliere(d, stand, soll, grund);
    }, function (e) {
      if (nr !== zustand.laufNr || istAbbruch(e)) return 'ueberholt';
      zustand.laufCtrl = null;
      zustand.vertrauenswuerdig = false;
      invariante(d);
      if (e && e.halongDaten) {
        // Server antwortet, aber nicht verwertbar: Impact selbst neu laden lassen (eigener Abruf per ?section_id).
        warnEinmal('daten', 'Warenkorb-Stand nicht verwertbar, Drawer wird neu geladen.', e);
        feuere('cart:refresh', null, document);
        return 'refresh';
      }
      warnEinmal('netz', 'Warenkorb konnte nicht abgeglichen werden (Netz). Nächster Versuch bei Rückkehr/Öffnen.', e);
      return 'netzfehler';
    });
  }

  /** Stufen bei Abweichung: offizielles Event, dann Drawer direkt ersetzen, dann cart:refresh, dann /cart. */
  function eskaliere(d, stand, soll, grund) {
    var st = zustand.stoerung && zustand.stoerung.sig === soll ? zustand.stoerung : (zustand.stoerung = { sig: soll, stufe: 0 });
    var stufe = st.stufe++;
    if (stufe > 0) zustand.zaehler.eskalationen++;
    log('Abweichung (' + grund + '), Stufe', stufe);
    if (stufe === 0) { meldeStand(stand, grund); return 'korrigiert'; }
    if (stufe === 1) { ersetzeDrawer(d, stand.html); planeAbgleich('nach-ersetzen'); return 'ersetzt'; }
    if (stufe === 2) { feuere('cart:refresh', null, document); planeAbgleich('nach-refresh', 1500); return 'refresh'; }
    // Stufe 3: Inhalt weicht dauerhaft ab (z. B. fremdes Script ändert Text). Solange die Invariante steht,
    // ist der Drawer bedienbar: nur warnen. Fehlt der Fuß bei Positionen, ist die Warenkorbseite der sichere Weg.
    if (invariante(d) === 'fuss-fehlt' && d.hasAttribute('open')) {
      warnEinmal('cart-seite', 'Drawer nicht reparierbar, Weiterleitung zur Warenkorbseite.');
      window.location.assign(wurzel() + 'cart');
      return 'cart-seite';
    }
    warnEinmal('abweichung', 'Drawer weicht dauerhaft vom Server-Stand ab; Fuß und Kasse sind gesichert.');
    zustand.erwartet = signatur(d);
    zustand.vertrauenswuerdig = true;
    return 'akzeptiert';
  }

  /* ---------- Nach dem Hinzufügen (Speisekarte, Wok) ---------- */

  /**
   * Ersetzt das bisherige "cart.js + ?sections + Events" der Speisekarte. Nur der letzte Aufruf zählt; ein
   * überholter Aufruf löst nichts aus und lehnt nicht ab. Wird nie abgelehnt (das Gericht liegt dann ja bereits im
   * Warenkorb, eine Fehlermeldung "nicht hinzugefügt" wäre falsch).
   */
  function nachHinzufuegen() {
    var d = beobachte();
    if (zustand.hinzuCtrl) zustand.hinzuCtrl.abort();
    bricheAbgleichAb();
    var ctrl = zustand.hinzuCtrl = new AbortController();
    var nr = ++zustand.hinzuNr;
    var s = d ? sektionenFuer(d) : { ids: [], id: null };

    if (!s.id) {
      // Kein Drawer auf der Seite (z. B. cartType "page"): nur Zähler und Theme informieren.
      return holeJson(wurzel() + 'cart.js', ctrl.signal).then(function (cart) {
        if (nr !== zustand.hinzuNr) return;
        zustand.hinzuCtrl = null;
        feuere('variant:add', { items: [], cart: cart });
        feuere('cart:change', { baseEvent: 'variant:add', cart: cart, halongGeprueft: true, halongQuelle: 'nach-hinzufuegen' });
      }).catch(function (e) { if (nr === zustand.hinzuNr) { zustand.hinzuCtrl = null; if (!istAbbruch(e)) warnEinmal('netz', 'Warenkorb nicht geladen.', e); } });
    }

    return mitWiederholung(function () { return holeStand(ctrl.signal, s.ids, s.id); }, ctrl.signal).then(function (stand) {
      if (nr !== zustand.hinzuNr) return;
      zustand.hinzuCtrl = null;
      zustand.stoerung = null;
      zustand.vertrauenswuerdig = true; // frischer Server-Stand: das Öffnen löst keinen zweiten Abruf aus
      feuere('variant:add', { items: [], cart: Object.assign({}, stand.cart, { sections: stand.sektionen }) });
      meldeStand(stand, 'nach-hinzufuegen');
    }, function (e) {
      if (nr !== zustand.hinzuNr || istAbbruch(e)) return;
      zustand.hinzuCtrl = null;
      zustand.vertrauenswuerdig = false;
      if (e && e.halongDaten) {
        warnEinmal('daten', 'Warenkorb-Stand nach dem Hinzufügen nicht verwertbar, Drawer wird neu geladen.', e);
        feuere('cart:refresh', null, document);
        planeAbgleich('nach-hinzufuegen-refresh', 1500);
      } else {
        warnEinmal('netz', 'Warenkorb nach dem Hinzufügen nicht geladen (Netz). Abgleich folgt.', e);
        planeAbgleich('nach-hinzufuegen-netz', 1500);
      }
    });
  }

  /* ---------- Ereignisse ---------- */

  function eventGueltig(detail, id) {
    if (!detail || !detail.cart || typeof detail.cart.item_count !== 'number') return false;
    if (!id) return true;
    var html = detail.cart.sections && detail.cart.sections[id];
    if (typeof html !== 'string') return false;
    var doc = parse(html);
    return !!(doc.querySelector('.cart-drawer') && doc.querySelector('.cart-drawer__inner') && doc.querySelector('[slot="footer"]'));
  }

  // Capture auf document: läuft vor den Theme-Listenern (Bubble-Phase auf document).
  document.addEventListener('cart:change', function (event) {
    var d = beobachte();
    if (d) { fokusMerken(d); if (!zustand.abholzeit) zustand.abholzeit = d.querySelector('halong-abholzeit'); }
    if (event.detail && event.detail.halongGeprueft) return;
    if (eventGueltig(event.detail, d ? sektionsId(d) : null)) return;
    // Ungültig (Live-Muster ohne sections, oder null aus der Vorschau): Impact würde einen TypeError werfen.
    event.stopImmediatePropagation();
    zustand.zaehler.geblockt++;
    zustand.vertrauenswuerdig = false;
    log('Ungültiges cart:change abgefangen, hole Server-Stand');
    planeAbgleich('ungueltiges-event', 0);
  }, true);

  // Bubble: nach Impact. Ruhezeit setzen und Prüfung planen.
  document.addEventListener('cart:change', function (event) {
    var detail = event.detail || {};
    var d = beobachte();
    if (!d) return;
    var jetzt = Date.now();
    if (zustand.ruheBis > jetzt) zustand.ueberlappend = true;
    // Impact: bei 0 Positionen Ausblenden (150 ms) und kompletter Austausch, sonst Inhalt nach 0 bzw. 1250 ms.
    var dauer = detail.cart.item_count === 0 ? IMPACT_LEER_ANIMATION_MS : (detail.baseEvent === 'variant:add' ? 0 : IMPACT_VERZOEGERUNG_MS);
    zustand.ruheBis = Math.max(zustand.ruheBis, jetzt + dauer + PUFFER_MS);
    var id = sektionsId(d);
    var html = id && detail.cart.sections && detail.cart.sections[id];
    if (typeof html === 'string') zustand.erwartet = signatur(parse(html));
    if (!detail.halongGeprueft) {
      bricheAbgleichAb();
      zustand.vertrauenswuerdig = false;
      // Läuft gerade nachHinzufuegen, kann dessen Antwort älter sein als dieses Event: danach immer gegen den Server.
      if (zustand.hinzuCtrl) zustand.ueberlappend = true;
    }
    if (!detail.halongGeprueft || detail.halongQuelle === 'nach-hinzufuegen') zustand.stoerung = null;
    invariante(d);
    fokusPruefen(d);
    clearTimeout(zustand.lokalTimer);
    zustand.lokalTimer = setTimeout(lokalePruefung, zustand.ruheBis - jetzt + PUFFER_MS);
  });

  // Impact LineItem (theme.js Z. 1778-1803) erwartet ein <pill-loader> in jeder Position; das Halong-Markup hat keins.
  // Ohne Ersatz wirft jede Mengenänderung/Entfernung im Drawer "Cannot read properties of null (reading 'setAttribute')".
  // Ersatz: ein nicht eingehängtes Element am Objekt, bevor Impacts Listener (Zielphase) laufen. Kein Eingriff in theme.js.
  ['line-item:will-change', 'line-item:change', 'line-item:error'].forEach(function (typ) {
    document.addEventListener(typ, function (event) {
      var li = event.target && event.target.closest ? event.target.closest('line-item') : null;
      if (li && !li.pillLoaderElement) li.pillLoaderElement = document.createElement('span');
    }, true);
  });

  document.addEventListener('cart:refresh', function () {
    var d = beobachte();
    if (!d) return;
    fokusMerken(d);
    zustand.vertrauenswuerdig = false;
    zustand.ueberlappend = true;
    planeAbgleich('cart-refresh', 1200);
  }, true);

  document.addEventListener('toggle', function (event) {
    var d = drawer();
    if (!d || event.target !== d || !d.hasAttribute('open')) return;
    if (!zustand.vertrauenswuerdig) abgleichen('drawer-geoeffnet');
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) { zustand.vertrauenswuerdig = false; zustand.ueberlappend = true; planeAbgleich('bfcache', 1200); } // Impact lädt selbst neu (_onPageShow)
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') { zustand.versteckt = Date.now(); return; }
    if (zustand.versteckt && Date.now() - zustand.versteckt > SICHTBAR_NACH_MS) planeAbgleich('tab-sichtbar', 0);
    zustand.versteckt = 0;
  });

  window.addEventListener('focus', function () {
    var jetzt = Date.now();
    if (jetzt - zustand.letzterFokusAbgleich < FOKUS_DROSSEL_MS) return;
    zustand.letzterFokusAbgleich = jetzt;
    planeAbgleich('fenster-fokus');
  });

  window.addEventListener('online', function () { if (!zustand.vertrauenswuerdig) planeAbgleich('wieder-online', 0); });

  /* ---------- Start ---------- */

  (function start() {
    var d = beobachte();
    if (!d) return;
    invariante(d);
    zustand.erwartet = signatur(d); // Server-Render beim Laden ist die Wahrheit
  })();

  window.__halongWarenkorb = Object.freeze({
    version: VERSION,
    nachHinzufuegen: nachHinzufuegen,
    abgleichen: function (grund) { return abgleichen(grund || 'extern'); },
    planeAbgleich: function (grund) { planeAbgleich(grund || 'extern'); },
    status: function () {
      return {
        version: VERSION,
        vertrauenswuerdig: zustand.vertrauenswuerdig,
        laeuft: !!(zustand.laufCtrl || zustand.hinzuCtrl),
        ruheBis: zustand.ruheBis,
        zaehler: Object.assign({}, zustand.zaehler)
      };
    }
  });
})();
